import axios from '@/allotment/axios'

export default {
  add: data => axios.post('/user/add/account', data), //添加用户
  page: data => axios.post('/user/select/page', data), //获取用户分页数据
  company: data => axios.get('/company/find/users', { params: data }), //获取企业用户数据
  status: data => axios.post('/user/update/status', data), //改变用户状态
  getInstall: () => axios.get('/user/find/install'), //获取所有安装商
  gethDeal: () => axios.get('/user/find/deal'), //获取所有经销商
  dealerGet: id => axios.get(`/concat/dealer/get/${id}`), //获取关联经销商
  dealerPost: data => axios.post('concat/dealer/save', data) //保存关联经销商
}
